import type { AdminMe } from '../api/useMe.ts';

/** Et arbeidsrom slik kontrakten kjenner det (`Room` i tenant.tsp). */
export type Rom = AdminMe['rooms'][number];

/**
 * Rommet sidene i dag hører til. Alle fem sidene i skallet (DD-01) er Innspills; den dagen
 * rommet Hypoteser får sider, spør de med sitt eget rom.
 */
export const INNSPILL: Rom = 'innspill';

/**
 * Navn og ikon per rom, ett sted: rom-bryteren, filteret og personsiden i Panelbrukere leser
 * herfra. `hypoteser` er vedtatt (H0.1, 2026-09-25) men ikke i kontraktens `Room` før H1.2 —
 * derfor er nøkkelen en streng. Prøverommene i wireframen (Undersøkelser, Samtaler) finnes
 * ikke og står ikke her (admin-panelbrukere.jsx, P4).
 */
const ROM: Record<string, { navn: string; ikon: string }> = {
  // DD-63: teleskopet er rommet Hypoteser sitt. Lyspæra er ØNSKETS og brukes aldri om et rom.
  innspill: { navn: 'Innspill', ikon: 'chatbubble-outline' },
  hypoteser: { navn: 'Hypoteser', ikon: 'telescope-outline' },
};

export const romNavn = (rom: string): string => ROM[rom]?.navn ?? rom;
export const romIkon = (rom: string): string => ROM[rom]?.ikon ?? 'chatbubble-outline';
